// Shared by the landing-page footer and Contact page.
export const gleecSocialLinks = {
  telegram: 'https://t.me/gleecBTCexchange/',
  youtube: 'https://www.youtube.com/@gleecofficial',
  facebook: 'https://www.facebook.com/gleecofficial',
  instagram: 'https://www.instagram.com/gleecofficial/',
};
